import { Component, computed, Input, input, InputSignal, OnInit, Signal } from '@angular/core';
import {
  ApplicationAppEntityApplicationRead, ShipmentAppEntityShipmentRead
} from '../../../../../openapi';
import { CommonModule, DatePipe } from '@angular/common';
import { LabelComponent } from '../../../../../common/label/label.component';
import { AccordionGroupComponent } from '../../../../../common/accordion-group/accordion-group.component';
import { AccordionItemComponent } from '../../../../../common/accordion-item/accordion-item.component';
import {
  ApplicantItemPreviewComponent
} from '../../common/applicant-data-section/components/applicant-item-preview/applicant-item-preview.component';
import {
  ApplicationDataPreviewComponent
} from '../../common/application-data-section/components/application-data-preview/application-data-preview.component';
import { OccupationLabelPipe } from '../../common/occupation-data-section/pipes/occupation-label.pipe';
import {
  OccupationPreviewComponent
} from '../../common/occupation-data-section/components/occupation-preview/occupation-preview.component';
import {
  occupationsToFormValue,
  RoadOccupationFormValue
} from '../../common/occupation-data-section/forms/road-occupation.form';
import {
  AgreementsDataPreviewComponent
} from '../../common/agreements-data-section/components/agreements-data-preview/agreements-data-preview.component';
import {
  AttachmentsDataPreviewComponent
} from '../../common/attachments-data-section/components/attachments-data-preview/attachments-data-preview.component';
import { EntityLabelPipe } from '../../../../../pipes/applicant-label.pipe';
import {
  ApplicantPreviewComponent
} from '../../common/applicant-data-section/components/applicant-preview/applicant-preview.component';
import { DecisionDataPreviewComponent } from '../../common/decision-data-preview/decision-data-preview.component';
import {
  ContractorDataPreviewComponent
} from '../../common/contractor-data-section/components/contractor-data-preview/contractor-data-preview.component';
import {
  PaymentsDataPreviewComponent
} from '../../common/payments-data-section/components/payments-data-preview/payments-data-preview.component';
import { ApplicationPayment } from '../../../../../services/application.common.model';
import { selectPayment } from '../../../../../store/selectors/application.selectors';
import { Store } from '@ngrx/store';

@Component({
  selector: 'app-notification-of-emergency-occupation-preview',
  standalone: true,
  imports: [
    CommonModule,
    DatePipe,
    LabelComponent,
    ApplicationDataPreviewComponent,
    OccupationPreviewComponent,
    AgreementsDataPreviewComponent,
    AttachmentsDataPreviewComponent,
    ApplicantPreviewComponent,
    DecisionDataPreviewComponent,
    ContractorDataPreviewComponent,
    PaymentsDataPreviewComponent
  ],
  templateUrl: './notification-of-emergency-occupation-preview.component.html'
})
export class NotificationOfEmergencyOccupationPreviewComponent implements OnInit {

  @Input()
  public expanded: boolean = true;

  public application: InputSignal<ApplicationAppEntityApplicationRead | null> = input<ApplicationAppEntityApplicationRead | null>(null);

  public shipments: InputSignal<ShipmentAppEntityShipmentRead[]> = input<ShipmentAppEntityShipmentRead[]>([]);

  public canPay: InputSignal<boolean> = input<boolean>(false);

  public payment: Signal<ApplicationPayment | null> = this.store$.selectSignal(selectPayment);

  public roadOccupation: Signal<RoadOccupationFormValue | null> = computed(() => occupationsToFormValue(this.application()?.roadOccupations || []).at(0) || null);

  constructor(
    private store$: Store
  ) {
  }

  public ngOnInit(): void {
  }
}
